<!-- Trigger to Open the Modal -->
<button type="button" class="btn bg-transparent px-4 py-0" data-bs-toggle="modal" data-bs-target="#categoryTagManagerModal" title="Manage categories and tags" aria-label="Manage categories and tags">
  <i class="bi bi-folder-fill fs-2"></i>
</button>


<teleport to="body">
<!-- Modal -->
<div class="modal fade" id="categoryTagManagerModal" tabindex="-1" aria-labelledby="category_tag_manager_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content category-tag-manager-modal">

      <div class="modal-header category-tag-manager-header">
        <div class="d-flex align-items-center gap-3">
          <span class="category-tag-manager-title-icon">
            <i class="bi bi-folder2-open"></i>
          </span>
          <div>
            <h6 id="category_tag_manager_label" class="modal-title category-tag-manager-title">Category & Tag Manager</h6>
            <p class="category-tag-manager-subtitle mb-0">Organise portal posts with clean categories and tags.</p>
          </div>
        </div>
        <button type="button" class="btn-close category-tag-manager-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body category-tag-manager-body">
        <!-- Add New Category Section -->
        <section class="category-tag-create-panel">
          <div class="category-tag-create-copy">
            <span class="category-tag-eyebrow">New category</span>
            <p class="text-muted text-xxs">Add a category for your portal content</p>
          </div>
          <div class="category-tag-create-form">
            <input
              type="text"
              v-model="category_name"
              @keypress.enter="handleKeyPress('category')"
              class="form-control form-control-sm category-tag-input"
              placeholder="Enter category name..."
            />
            <button
              class="btn btn-primary btn-sm"
              :disabled="!category_name.trim()"
              @click="() => handleKeyPress('category')"
              title="Save category"
              aria-label="Save category"
            >
              <span>Save</span>
            </button>
          </div>
        </section>


        <!-- Categories List -->
        <div v-if="categories.length === 0" class="category-tag-empty">
          <span class="category-tag-empty-icon">
            <i class="bi bi-tags"></i>
          </span>
          <h6>No categories yet</h6>
          <p>Create your first category above, then add tags inside it.</p>
        </div>

        <div v-else class="category-tag-card-list">
          <div
            v-for="category in categories"
            :key="category.id"
            class="category-tag-card"
          >
            <div class="category-tag-card-header">
              <div class="category-tag-card-title">
                <span class="category-tag-card-icon">
                  <i class="bi bi-folder-fill"></i>
                </span>
                <div class="min-w-0">
                  <h6>{{ category.name }}</h6>
                  <span>
                  {{ category.tags?.length || 0 }} tags
                  </span>
                </div>
              </div>
              <div class="category-tag-card-actions">
                <button
                  class="category-tag-icon-btn"
                  @click.prevent="openEditCategoryModal(category)"
                  title="Edit category"
                  aria-label="Edit category"
                >
                  <i class="bi bi-pencil-fill"></i>
                </button>

                <button
                  class="category-tag-icon-btn category-tag-icon-btn-danger"
                  @click.prevent="delete_category(category.id)"
                  title="Delete category"
                  aria-label="Delete category"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>

            </div>

            <div class="category-tag-card-body">
              <!-- Add Tag Input -->
              <div class="category-tag-add-row">
                <input
                  type="text"
                  :value="tag_name.get(category.id) || ''"
                  @input="e => handleTagInputChange(category.id, e.target.value)"
                  @keypress.enter="handleKeyPress('tag', category.id)"
                  class="form-control form-control-sm category-tag-input"
                  placeholder="Enter tag name..."

                />
                <button
                  class="btn btn-outline-primary btn-sm"
                  :disabled="!(tag_name.get(category.id) || '').trim()"
                  @click="() => addTag(category.id)"
                  title="Add tag"
                  aria-label="Add tag"
                >
                  <span>Add</span>
                </button>
              </div>


              <!-- Tag List -->
              <div v-if="category.tags && category.tags.length === 0" class="category-tag-empty-card">
                <i class="bi bi-tag"></i>
                No tags yet. Add the first one above.
              </div>
              <div v-else class="category-tag-chip-list">
<div
  v-for="tag in category.tags"
  :key="tag.id"
  class="category-tag-chip"
>
  <i class="bi bi-tag"></i>

  <!-- Text -->
  <span class="category-tag-chip-text">
    {{ tag.name }}
  </span>

  <!-- Actions -->
  <div class="category-tag-chip-actions">
    <button
      class="category-tag-chip-action"
      @click="openEditModal(category.id, tag)"
      title="Edit tag"
      aria-label="Edit tag"
    >
      <i class="bi bi-pencil"></i>
    </button>

    <button
      class="category-tag-chip-action category-tag-chip-action-danger"
      @click="delete_tag(tag.id, category.id)"
      title="Delete tag"
      aria-label="Delete tag"
    >
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>


</div>
            </div>

          </div>
        </div>

        <!-- Summary -->
        <div class="category-tag-summary">
          <div><i class="bi bi-folder"></i> {{ categories.length }} Categories</div>
          <div><i class="bi bi-tag"></i> {{ totalTags }} Total Tags</div>
        </div>
      </div>

      <div class="modal-footer category-tag-manager-footer">
        <button
          class="btn btn-sm btn-primary category-tag-save-all"
          :disabled="categories.length === 0"
          @click="create_tag_category"
          title="Save all categories and tags"
          aria-label="Save all categories and tags"
        >
          <i class="bi bi-check-circle me-1"></i> Save All
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Single Edit Category Modal -->
<div
  class="modal fade"
  id="editCategoryModal"
  tabindex="-1"
  aria-labelledby="editCategoryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-5 shadow scrollable-container">

      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs" id="editCategoryModalLabel">Edit Category</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
      </div>

      <div class="modal-body">
        <input
          type="text"
          class="form-control shadow-sm rounded-5 text-xs"
          v-model="edit_category"
          placeholder="Category Name"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          @click="update_category()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Single Edit Tag Modal -->
 <div
  class="modal fade"
  id="editTagModal"
  tabindex="-1"
  aria-labelledby="editTagModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-5">

      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs" id="editTagModalLabel">Edit Tag</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
      </div>

      <div class="modal-body">
        <input
          type="text"
          class="form-control shadow-sm rounded-5 text-xs"
          v-model="edit_tag_name"
          placeholder="Tag Name"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          @click="update_tag()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

</teleport>
